import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';

export interface AuthManagerLoginPayload {
  identity: string;
  password: string;
  remember_me?: boolean;
}

export interface AuthUserResponse {
  status: 'success' | 'error';
  data: {
    token?: string;
    user?: any;
    subscription_expired?: boolean;
  };
  message?: string;
  error_code?: string;
  retry_after?: number;
}

@Injectable({ providedIn: 'root' })
export class AuthApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  login(payload: AuthManagerLoginPayload): Observable<AuthUserResponse> {
    return this.http.post<AuthUserResponse>(`${this.rootUrl}/api/v1/super-admin/auth/login`, payload);
  }

  getCurrentUser(): Observable<AuthUserResponse> {
    return this.http.get<AuthUserResponse>(`${this.rootUrl}/api/v1/super-admin/auth/me`);
  }

  logout(): Observable<{ status: string }> {
    return this.http.post<{ status: string }>(`${this.rootUrl}/api/v1/super-admin/auth/logout`, {});
  }

  refreshToken(): Observable<AuthUserResponse> {
    return this.http.post<AuthUserResponse>(`${this.rootUrl}/api/v1/super-admin/auth/refresh`, {});
  }

  verifyMfaChallenge(payload: { challenge_token: string; code?: string; recovery_code?: string }): Observable<AuthUserResponse> {
    return this.http.post<AuthUserResponse>(`${this.rootUrl}/api/v1/super-admin/auth/mfa/challenge`, payload);
  }

  getMfaStatus(): Observable<{ status: string; data: { enabled: boolean; enabled_at: string | null; recovery_codes_count: number } }> {
    return this.http.get<any>(`${this.rootUrl}/api/v1/super-admin/auth/mfa/status`);
  }

  setupMfa(): Observable<{ status: string; data: { secret: string; qr_uri: string; qr_image?: string; issuer: string; account: string }; message?: string }> {
    return this.http.post<any>(`${this.rootUrl}/api/v1/super-admin/auth/mfa/setup`, {});
  }

  confirmMfa(code: string): Observable<{ status: string; data: { recovery_codes: string[] }; message?: string }> {
    return this.http.post<any>(`${this.rootUrl}/api/v1/super-admin/auth/mfa/confirm`, { code });
  }

  regenerateMfaRecoveryCodes(payload: { password?: string; code?: string }): Observable<{ status: string; data: { recovery_codes: string[] }; message?: string }> {
    return this.http.post<any>(`${this.rootUrl}/api/v1/super-admin/auth/mfa/recovery-codes`, payload);
  }

  disableMfa(payload: { password: string; code?: string; recovery_code?: string }): Observable<{ status: string; message?: string }> {
    return this.http.post<any>(`${this.rootUrl}/api/v1/super-admin/auth/mfa/disable`, payload);
  }
}
